import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import UserManagementActions from "../../Actions/UserManagementActions";
import UsermanagementConstants from "../../Constants/UsermanagementConstants";
import usermanagementStore from "../../Stores/UsermanagementStore";
import Addnewuser from "./Addnewuser";
import { customizeFilter } from "../FilterOptions/CustomizeFilter";
import DisableEnableUser from "./DisableEnableUser";
import { MdEdit, MdPersonAdd } from "react-icons/md";
import { CgBlock, CgUnblock } from "react-icons/cg";
import { BiReset } from "react-icons/bi";
import { BsFillPersonLinesFill, BsFillPersonPlusFill } from "react-icons/bs";
import AddRole from "./AddRole";
import ViewRole from "./ViewRole";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";
import ConfirmationPopUp from "../MessageBox/ConfirmationPopUp";
import AddCostCentreForUser from "./AddCostCentreForUser";
import UploadFileOutlinedIcon from "@mui/icons-material/UploadFileOutlined";
import {
  useAlertMessageContext,
  useAlertMessageActionsContext,
} from "../../Context/AlertMessageContext";
import { useLanguageContext } from "../../Context/LanguageContext";
import commonUtils from "../../helpers/commonUtils";
import { useRef } from "react";
import { useCallback } from "react";
import _ from "lodash";
import AlertMessage from "../MessageBox/AlertMessage";
import { useSelectedConfigActionContext } from "../../Context/GlobalContext";
import CustomDataGrid from "../ReusableComponent/DataGrid/CustomizeDataGrid";
import { Button } from "@mui/material";
import ImportAction from "../../Actions/ImportAction";
import ImportComponent from "../ReusableComponent/ImportComponent/importComponent";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import {
  useTourGuidStartActionsContext,
  useTourGuidSavedSettingContext,
  useTourGuidSavedSettingActionsContext,
} from "../../Context/TourGuidContext";
import { TourGuideHelper } from "../../helpers/TourGuide/TourGuideHelper";
import { GridActionsCellItem } from "@mui/x-data-grid-pro";
const Masterpage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { localization } = useLanguageContext();
  const UpdateTourStatus = useTourGuidStartActionsContext();
  const tourGuidSaveSetting = useTourGuidSavedSettingContext();
  const setTourGuidSaveSetting = useTourGuidSavedSettingActionsContext();
  const { showAlertMessage, isAlertSuccess, alertMessage } =
    useAlertMessageContext();
  const [userId, setUserId] = useState(0);
  const [userlist, setUserList] = useState([]);
  const [userdetails, setUserDetails] = useState("");
  const [userRoleList, setUserRoleList] = useState([]);
  const [editRoleDetails, setEditRoleDetails] = useState("");
  const [addCostCentreDetails, setAddCostCentreDetails] = useState("");
  const [isAddRole, setIsAddRole] = useState(true);
  const [costCentreListForUser, setCostCentreListForUser] = useState([]);
  const [confirmationPopUpOpen, setConfirmationPopUpOpen] = useState(false);
  const [confirmationPopUpMsg, setConfirmationPopUpMsg] = useState("");
  const [callbackData, setCallbackData] = useState(null);
  const [eventType, setEventType] = useState(null);
  const [costCentreList, setCostCentreList] = useState([]);
  const [originalUserData, setOriginalUserData] = useState([]);
  const [firstName, setFirstName] = useState("");
  const [Surname, setSurName] = useState("");
  const [selectStatus, setSelectStatus] = useState();
  const [selectExtern, setSelectExtern] = useState();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const importIntial = {
    isOpen: false,
    headerTitle: localization.importUser,
    subHeaderTitle: localization.importUserTitle,
    handleClose: handleCloseImport,
    handleImport: handleImport,
    handleDownloadTemplate: handleDownloadTemplate,
    key: "User",
  };
  const [openImport, setOpenImport] = useState(importIntial);
  const debounceFunction = useCallback(
    _.debounce(handleDebounceFunction, 1000),
    [],
  );
  const [passDialogFlag, setPassDialogFlag] = useState(false);
  const FirstName = useRef("");
  const SurName = useRef("");
  const currentUserId = useRef("");
  const { setAlertMessageFromAPI } = useAlertMessageActionsContext();

  const activeTranslation = [
    "ativo",
    "aktiv",
    "active",
    "actif",
    "aktív",
    "सक्रिय",
  ];
  const filterData = useRef({
    WerkID: "",
    Vorname: "",
    Nachname: "",
    Username: "",
    PersonalNr: "",
    Aktiv: null,
    IsExtern: "",
    Email: "",
  });
  const updateSelectedConfig = useSelectedConfigActionContext();

  const columns = [
    {
      field: "vorname",
      headerName: localization.firstName,
      hideable: false,
      flex: 1,
    },
    {
      field: "actions",
      type: "actions",
      headerName: localization.actions,
      width: 45,
      hideable: false,
      getActions: (params) => [...getAction(params, localization)],
    },
    { field: "nachname", headerName: localization.surname, flex: 1 },
    { field: "username", headerName: localization.username, flex: 1 },
    { field: "email", headerName: localization.email, flex: 1 },
    { field: "personalNr", headerName: localization.personalNumber, flex: 1 },
    { field: "plantID", headerName: localization.plant, flex: 1 },
    { field: "lastLoginOn", headerName: localization.lastLoginOnWeb, flex: 1 },
    {
      field: "mobileLoginOn",
      headerName: localization.lastLoginOnApp,
      flex: 1,
    },
    {
      field: "isExtern",
      headerName: localization.extern,
      valueGetter: (params) =>
        params.value ? localization.yes : localization.no,
      flex: 1,
    },
    {
      field: "aktiv",
      headerName: localization.active,
      type: "string",
      flex: 1,
      valueGetter: (params) =>
        params.value ? localization.active : localization.inActive,
      renderCell: (params) => {
        return handleCellStyle(params.value);
      },
    },
    // { field: "id", headerName: "ID" },
    // { field: "passwort", headerName: "passwort" },
  ];

  const columnStyles = ["aktiv"];

  const unblockUser = (id) => {
    UserManagementActions.UnblockUser(id);
  };

  const getFilteredUsers = () => {
    UserManagementActions.getFilteredUsers(filterData);
    setGlobalSpinner(true);
  };

  const getUsersRole = (id) => {
    setGlobalSpinner(true);
    UserManagementActions.getUserRoles(id);
  };

  const getCostCentreForUser = (id) => {
    setGlobalSpinner(true);
    UserManagementActions.getCostCentreForUser(id);
  };

  const getCostCentreByWerkId = (werkId) => {
    UserManagementActions.getCostCentreByWerkId(werkId);
  };

  const resetUserPassword = (userid) => {
    UserManagementActions.resetUserPassword(userid);
    setGlobalSpinner(true);
  };

  const resetFilterData = () => {
    filterData.current.WerkID = "";
    filterData.current.Vorname = "";
    filterData.current.Nachname = "";
    filterData.current.Username = "";
    filterData.current.PersonalNr = "";
    filterData.current.Aktiv = null;
    filterData.current.IsExtern = "";
    filterData.current.Email = "";
    setFirstName("");
    setSurName("");
    setSelectStatus("");
    setSelectExtern("");
    getFilteredUsers();
  };

  const [orderSymbol, setOrderSymbol] = useState({
    columName: "vorname",
    className: "glyphicon glyphicon-chevron-up",
  });
  const [orderKey, setOrderKey] = useState("Asc");
  function handleDebounceFunction(val) {
    getFilteredUsers();
  }

  useEffect(() => {
    if (location.pathname === "/setting") {
      navigate("/setting/masterpage");
    }
  }, [location, navigate]);

  useEffect(() => {
    getFilteredUsers();
    function getFilteredUserSuccess() {
      const res = usermanagementStore.getFilteredUserResponse();
      if (res.length > 0) {
        const tableData = res.map((item) => ({
          ...item,
          aktiv: item.aktiv ? localization.active : localization.inActive,
          isExtern: item.isExtern ? localization.yes : localization.no,
        }));
        setUserList(res);
        setOriginalUserData(res);

        const tourStatus = TourGuideHelper.returnCurrentTourState(
          tourGuidSaveSetting,
          setTourGuidSaveSetting,
          "SettingsViewTour",
        );

        if (tourStatus.length > 0) {
          UpdateTourStatus({
            tourTitle: tourStatus[0].title,
            tourStatus: true,
            anyStep: 0,
          });
        }
      } else {
        setUserList([]);
        setOriginalUserData([]);
      }
      updateSelectedConfig("user");
      setGlobalSpinner(false);
    }

    function getFilteredUserFailure() {
      var res = usermanagementStore.getFilteredUserResponse();
      updateSelectedConfig("user");
      setGlobalSpinner(false);
    }

    function unblockUserSuccess() {
      var res = usermanagementStore.getUnBlockUserResult();

      if (res) {
        toast.success(localization.userUnblockedMsg);
        getFilteredUsers();
      }
    }

    function unblockUserFailure() {
      var res = usermanagementStore.getUnBlockUserResult();

      if (res) {
        toast.error(res);
      }
    }

    usermanagementStore.addChangeListener(
      UsermanagementConstants.GET_FILTERED_USER_SUCCESS,
      getFilteredUserSuccess,
    );

    usermanagementStore.addChangeListener(
      UsermanagementConstants.GET_FILTERED_USER_FAILURE,
      getFilteredUserFailure,
    );

    usermanagementStore.addChangeListener(
      UsermanagementConstants.UNBLOCK_USER_SUCCESS,
      unblockUserSuccess,
    );

    usermanagementStore.addChangeListener(
      UsermanagementConstants.UNBLOCK_USER_FAILURE,
      unblockUserFailure,
    );

    return () => {
      usermanagementStore.removeChangeListener(
        UsermanagementConstants.GET_FILTERED_USER_SUCCESS,
        getFilteredUserSuccess,
      );

      usermanagementStore.removeChangeListener(
        UsermanagementConstants.GET_FILTERED_USER_FAILURE,
        getFilteredUserFailure,
      );

      usermanagementStore.removeChangeListener(
        UsermanagementConstants.UNBLOCK_USER_SUCCESS,
        unblockUserSuccess,
      );

      usermanagementStore.removeChangeListener(
        UsermanagementConstants.UNBLOCK_USER_FAILURE,
        unblockUserFailure,
      );
    };
  }, [setUserList]);

  const setCurrentUserDetails = (row) => {
    setUserDetails(row);
  };

  //-----------------------add user section start-------------------------
  useEffect(() => {
    function addUserSuccess() {
      const res = usermanagementStore.getAddOrUpdateUser();
      if (res) {
        commonUtils.hideModalPopUp("addNewUserModalClose");
        toast.success(
          commonUtils.getIsEdit()
            ? localization.userEditedSuccessfully
            : localization.userAddedSuccessfully,
        );
        setGlobalSpinner(false);
        getFilteredUsers();
      }
    }

    function addUserFailure() {
      var res = usermanagementStore.getAddOrUpdateUser();
      toast.error(res);
      setGlobalSpinner(false);
    }

    usermanagementStore.addChangeListener(
      UsermanagementConstants.ADDORUPDATE_USER_SUCCESS,
      addUserSuccess,
    );

    usermanagementStore.addChangeListener(
      UsermanagementConstants.ADDORUPDATE_USER_FAILURE,
      addUserFailure,
    );

    return () => {
      usermanagementStore.removeChangeListener(
        UsermanagementConstants.ADDORUPDATE_USER_SUCCESS,
        addUserSuccess,
      );

      usermanagementStore.removeChangeListener(
        UsermanagementConstants.ADDORUPDATE_USER_FAILURE,
        addUserFailure,
      );
    };
  }, []);

  const handleAdd = () => {
    setUserDetails("");
  };

  function RenderAddUserButton() {
    return (
      <>
        <Button
          id="addNewUserTest"
          className="mr-4 cursorPoint svgIcon"
          variant="outlined"
          startIcon={<MdPersonAdd />}
          data-toggle="modal"
          data-target="#addNewUser"
        >
          {localization.add}
        </Button>
      </>
    );
  }

  const handleEdit = (row) => {
    const _temp = {
      ...row,
      aktiv: row["aktiv"] ? true : false,
      isExtern: row["isExtern"] ? true : false,
    };
    setCurrentUserDetails(_temp);
  };

  function RenderEditButton() {
    return (
      <>
        <Button
          id="addNewUserEditTest"
          className="mr-4 cursorPoint svgIcon"
          variant="outlined"
          startIcon={<MdEdit />}
          data-toggle="modal"
          data-target="#addNewUser"
        >
          {localization.toolTipEdit}
        </Button>
      </>
    );
  }

  const handleRoleAdd = (row) => {
    setUserId(row.id);
    setEditRoleDetails("");
    setIsAddRole(true);
  };

  function RenderAddRoleButton(props) {
    return (
      <Button
        id="addRoleModalTest"
        className="mr-4 cursorPoint svgIcon"
        variant="outlined"
        startIcon={<BsFillPersonPlusFill />}
        data-toggle="modal"
        data-target="#addRoleModal"
      >
        {localization.addRole}
      </Button>
    );
  }
  const handleResetPassword = (row) => {
    setUserId(row.id);
    setConfirmationPopUpOpen(true);
    setConfirmationPopUpMsg(localization.resetPasswordConfirmation);
    setCallbackData({
      userid: row.id,
    });
    setEventType("RESET_USER_PASSWORD");
  };

  function RenderResetpasswordButton() {
    return (
      <Button
        id="editHerstellerTest"
        className="mr-4 cursorPoint svgIcon"
        variant="outlined"
        startIcon={<BiReset />}
      >
        {localization.resetPassword}
      </Button>
      // <BiReset

      //   className="cursorPoint svgIcon"
      //   title={localization.resetPassword}
      //   size={20}
      //   onClick={() => {
      //     setUserId(userid);
      //     setConfirmationPopUpOpen(true);
      //     setConfirmationPopUpMsg(localization.resetPasswordConfirmation);
      //     setCallbackData({
      //       userid: userid,
      //     });
      //     setEventType("RESET_USER_PASSWORD");
      //   }}
      // />
    );
  }
  const handleViewRole = (row) => {
    setUserId(row.id);
    setCurrentUserDetails(row);
    currentUserId.current = row.id;
    getUsersRole(row.id);
    getCostCentreForUser(row.id);
  };
  function RenderViewRoleButton() {
    return (
      <Button
        id="viewRoleModalTest"
        className="mr-4 cursorPoint svgIcon"
        variant="outlined"
        startIcon={<BsFillPersonLinesFill />}
        data-toggle="modal"
        data-target="#viewRoleModal"
      >
        {localization.viewRole}
      </Button>
    );
  }

  function handleImportClick() {
    setOpenImport((prev) => ({
      ...prev,
      isOpen: true,
    }));
  }
  function RenderImportButton() {
    return (
      <Button
        id="import"
        className="svgIcon cursorPoint"
        variant="outlined"
        startIcon={<UploadFileOutlinedIcon />}
        onClick={handleImportClick}
      >
        {localization.import}
      </Button>
    );
  }
  //-----------------------add user section end-------------------------

  //-----------------------block and unblock user section start-------------------------
  useEffect(() => {
    function blockUserSuccess() {
      var res = usermanagementStore.getBlockUserResult();

      toast.success(localization.userBlockedMsg);
      commonUtils.hideModalPopUp("blockModalClose");
      setGlobalSpinner(false);
      getFilteredUsers();
    }

    function blockUserFailure() {
      var res = usermanagementStore.getBlockUserResult();

      setGlobalSpinner(false);
      toast.error(res);
    }

    usermanagementStore.addChangeListener(
      UsermanagementConstants.BLOCK_USER_SUCCESS,
      blockUserSuccess,
    );

    usermanagementStore.addChangeListener(
      UsermanagementConstants.BLOCK_USER_FAILURE,
      blockUserFailure,
    );

    return () => {
      usermanagementStore.removeChangeListener(
        UsermanagementConstants.BLOCK_USER_SUCCESS,
        blockUserSuccess,
      );

      usermanagementStore.removeChangeListener(
        UsermanagementConstants.BLOCK_USER_FAILURE,
        blockUserFailure,
      );
    };
  }, []);

  useEffect(() => {
    function resetUserPasswordSuccess() {
      var res = usermanagementStore.getUserPasswordResetResult();

      setGlobalSpinner(false);
      if (res) {
        setAlertMessageFromAPI(
          true,
          true,
          localization.passwordResetTo + " " + res.password,
        );
      }
    }

    function resetUserPasswordFailure() {
      var res = usermanagementStore.getUserPasswordResetResult();

      toast.error(res);
      setGlobalSpinner(false);
    }

    usermanagementStore.addChangeListener(
      UsermanagementConstants.RESET_USER_PASSWORD_SUCCESS,
      resetUserPasswordSuccess,
    );

    usermanagementStore.addChangeListener(
      UsermanagementConstants.RESET_USER_PASSWORD_FAILURE,
      resetUserPasswordFailure,
    );

    return () => {
      usermanagementStore.removeChangeListener(
        UsermanagementConstants.RESET_USER_PASSWORD_SUCCESS,
        resetUserPasswordSuccess,
      );

      usermanagementStore.removeChangeListener(
        UsermanagementConstants.RESET_USER_PASSWORD_FAILURE,
        resetUserPasswordFailure,
      );
    };
  }, []);

  const handleBlockUser = (row) => {
    setUserId(row.id);
  };

  function RenderBlockUser() {
    return (
      <Button
        id="disableUserTest"
        className="mr-4 cursorPoint svgIcon"
        variant="outlined"
        startIcon={<CgBlock />}
        data-toggle="modal"
        data-target="#blockModal"
      >
        {localization.block}
      </Button>
    );
  }
  const handleUnBlockUser = (row) => {
    setUserId(row.id);
    setConfirmationPopUpOpen(true);
    setConfirmationPopUpMsg(localization.enableUserConfirmation);
    setCallbackData({
      userid: row.id,
    });
    setEventType("ENABLE_USER");
  };
  function RenderUnBlockUser() {
    return (
      <Button
        id="enableUserTest"
        className="mr-4 cursorPoint svgIcon"
        variant="outlined"
        startIcon={<CgUnblock />}
      >
        {localization.unblock}
      </Button>
    );
  }

  //-----------------------block and unblock user section end-------------------------

  //-----------------------Add Role section start -------------------------------------
  useEffect(() => {
    function addOrUpdateRoleSuccess() {
      var res = usermanagementStore.getAddOrUpdateRoleResult();

      setGlobalSpinner(false);
      commonUtils.hideModalPopUp("addRoleModalClose");
      toast.success(
        commonUtils.getIsEdit()
          ? localization.roleEditedSuccessfully
          : localization.roleAddedSuccessfully,
      );
      getFilteredUsers();
    }

    function addOrUpdateRoleFailure() {
      var res = usermanagementStore.getAddOrUpdateRoleResult();

      setGlobalSpinner(false);
      toast.error(res);
    }

    usermanagementStore.addChangeListener(
      UsermanagementConstants.ADDORUPDATE_ROLE_SUCCESS,
      addOrUpdateRoleSuccess,
    );

    usermanagementStore.addChangeListener(
      UsermanagementConstants.ADDORUPDATE_ROLE_FAILURE,
      addOrUpdateRoleFailure,
    );

    return () => {
      usermanagementStore.removeChangeListener(
        UsermanagementConstants.ADDORUPDATE_ROLE_SUCCESS,
        addOrUpdateRoleSuccess,
      );

      usermanagementStore.removeChangeListener(
        UsermanagementConstants.ADDORUPDATE_ROLE_FAILURE,
        addOrUpdateRoleFailure,
      );
    };
  }, []);

  //-----------------------Add Role section end ----------------------------------------

  //------------------------View Role section start ------------------------------------
  const deleteRoleForUser = (userRoleId) => {
    setGlobalSpinner(true);
    UserManagementActions.deleteRoleForUser(userRoleId);
  };

  const deleteCostCentreForUser = (userRoleId, costCentreId) => {
    setGlobalSpinner(true);
    UserManagementActions.deleteCostCentreForUser(userRoleId, costCentreId);
  };

  useEffect(() => {
    function getUserRoleSuccess() {
      var res = usermanagementStore.getUserRoleListResult();

      if (res.length > 0) {
        setUserRoleList(res);
      } else {
        setUserRoleList([]);
      }
    }

    function getUserRoleFailure() {
      var res = usermanagementStore.getUserRoleListResult();

      setUserRoleList([]);
      setGlobalSpinner(false);
    }

    usermanagementStore.addChangeListener(
      UsermanagementConstants.GET_USER_ROLE_SUCCESS,
      getUserRoleSuccess,
    );

    usermanagementStore.addChangeListener(
      UsermanagementConstants.GET_USER_ROLE_FAILURE,
      getUserRoleFailure,
    );

    return () => {
      usermanagementStore.removeChangeListener(
        UsermanagementConstants.GET_USER_ROLE_SUCCESS,
        getUserRoleSuccess,
      );

      usermanagementStore.removeChangeListener(
        UsermanagementConstants.GET_USER_ROLE_FAILURE,
        getUserRoleFailure,
      );
    };
  }, [setUserRoleList]);

  useEffect(() => {
    function costCentreForUserSuccess() {
      var res = usermanagementStore.getCostCentreForUserResult();

      if (res) {
        setCostCentreListForUser(res);
      } else {
        setCostCentreListForUser([]);
      }
      setGlobalSpinner(false);
    }

    function costCentreForUserFailure() {
      var res = usermanagementStore.getCostCentreForUserResult();

      setGlobalSpinner(false);
    }

    usermanagementStore.addChangeListener(
      UsermanagementConstants.GET_COST_CENTRE_FOR_USER_SUCCESS,
      costCentreForUserSuccess,
    );

    usermanagementStore.addChangeListener(
      UsermanagementConstants.GET_COST_CENTRE_FOR_USER_FAILURE,
      costCentreForUserFailure,
    );

    return () => {
      usermanagementStore.removeChangeListener(
        UsermanagementConstants.GET_COST_CENTRE_FOR_USER_SUCCESS,
        costCentreForUserSuccess,
      );

      usermanagementStore.removeChangeListener(
        UsermanagementConstants.GET_COST_CENTRE_FOR_USER_FAILURE,
        costCentreForUserFailure,
      );
    };
  }, []);

  //---------------------------Get cost centre by werk id section----------------------------------------------------
  useEffect(() => {
    function getCostCentreByWerkIdSuccess() {
      var res = usermanagementStore.getPlantCostCenter();

      if (res.length > 0) {
        setCostCentreList(res);
      } else {
        setCostCentreList([]);
      }
    }

    function getCostCentreByWerkIdFailure() {}

    usermanagementStore.addChangeListener(
      UsermanagementConstants.GET_PLANT_COST_CENTER_SUCCESS,
      getCostCentreByWerkIdSuccess,
    );

    usermanagementStore.addChangeListener(
      UsermanagementConstants.GET_PLANT_COST_CENTER_FAILURE,
      getCostCentreByWerkIdFailure,
    );

    return () => {
      usermanagementStore.removeChangeListener(
        UsermanagementConstants.GET_PLANT_COST_CENTER_SUCCESS,
        getCostCentreByWerkIdSuccess,
      );
      usermanagementStore.removeChangeListener(
        UsermanagementConstants.GET_PLANT_COST_CENTER_FAILURE,
        getCostCentreByWerkIdFailure,
      );
    };
  }, []);
  //-----------------------------------------------------------------------------------------------------------------
  useEffect(() => {
    function deleteRoleForUserSuccess() {
      var res = usermanagementStore.getDeleteRoleForUserResult();

      setGlobalSpinner(false);
      toast.success(localization.roleDeletedSuccessfully);
      getUsersRole(currentUserId.current);
      getCostCentreForUser(currentUserId.current);
    }

    function deleteRoleForUserFailure() {
      var res = usermanagementStore.getDeleteRoleForUserResult();

      setGlobalSpinner(false);
      toast.error(res);
    }

    usermanagementStore.addChangeListener(
      UsermanagementConstants.DELETE_ROLE_FOR_USER_SUCCESS,
      deleteRoleForUserSuccess,
    );

    usermanagementStore.addChangeListener(
      UsermanagementConstants.DELETE_ROLE_FOR_USER_FAILURE,
      deleteRoleForUserFailure,
    );

    return () => {
      usermanagementStore.removeChangeListener(
        UsermanagementConstants.DELETE_ROLE_FOR_USER_SUCCESS,
        deleteRoleForUserSuccess,
      );

      usermanagementStore.removeChangeListener(
        UsermanagementConstants.DELETE_ROLE_FOR_USER_FAILURE,
        deleteRoleForUserFailure,
      );
    };
  }, []);

  useEffect(() => {
    function deleteCostCentreForUserSuccess() {
      var res = usermanagementStore.getDeleteCostCentreForUserResult();

      setGlobalSpinner(false);
      toast.success(localization.costCenterDeletedMsg);
      getCostCentreForUser(currentUserId.current);
    }

    function deleteCostCentreForUserFailure() {
      var res = usermanagementStore.getDeleteCostCentreForUserResult();

      setGlobalSpinner(false);
      toast.error(res);
    }

    usermanagementStore.addChangeListener(
      UsermanagementConstants.DELETE_COST_CENTRE_FOR_USER_SUCCESS,
      deleteCostCentreForUserSuccess,
    );

    usermanagementStore.addChangeListener(
      UsermanagementConstants.DELETE_COST_CENTRE_FOR_USER_FAILURE,
      deleteCostCentreForUserFailure,
    );

    return () => {
      usermanagementStore.removeChangeListener(
        UsermanagementConstants.DELETE_COST_CENTRE_FOR_USER_SUCCESS,
        deleteCostCentreForUserSuccess,
      );

      usermanagementStore.removeChangeListener(
        UsermanagementConstants.DELETE_COST_CENTRE_FOR_USER_FAILURE,
        deleteCostCentreForUserFailure,
      );
    };
  }, []);

  function editRoleFuntionCallback(editRoleDetails) {
    setEditRoleDetails(editRoleDetails);
    setIsAddRole(true);
  }

  function addCostCentreFuntionCallback(addCostCentreDetails) {
    setAddCostCentreDetails(addCostCentreDetails);
    getCostCentreByWerkId(addCostCentreDetails.werkId);
  }

  function editCostCentreFunctionCallback(editCostCentrRoleDetails) {
    setEditRoleDetails(editCostCentrRoleDetails);
  }

  function deleteRoleCallback(id, userDetails) {
    setConfirmationPopUpOpen(true);
    setConfirmationPopUpMsg(localization.deleteRoleConfirmation);
    setCallbackData({
      userRoleId: id,
    });
    setEventType("DELETE_ROLE");
  }

  function deleteCostCentreCallback(roleId, costCentreId, userDetails) {
    setConfirmationPopUpOpen(true);
    setConfirmationPopUpMsg(localization.deleteConfirmation);
    setCallbackData({
      roleId: roleId,
      costCentreId: costCentreId,
    });
    setEventType("DELETE_COST_CENTRE");
  }

  function closeViewRolePopUpCallback() {
    setUserDetails("");
    setUserRoleList("");
    setCostCentreListForUser("");
  }

  //------------------------View Role section end ------------------------------------

  //------------------------Add or update cost centre section start --------------------
  useEffect(() => {
    function addOrUpdateCostCentreSuccess() {
      var res = usermanagementStore.getCostCentreAddOrUpdateResult();

      setGlobalSpinner(false);
      commonUtils.hideModalPopUp("addCostCentreForUserClose");
      toast.success(localization.costCenterAddedSuccessfully);
      getCostCentreForUser(currentUserId.current);
    }

    function addOrUpdateCostCentreFailure() {
      var res = usermanagementStore.getCostCentreAddOrUpdateResult();

      setGlobalSpinner(false);
      toast.error(res);
    }

    usermanagementStore.addChangeListener(
      UsermanagementConstants.ADDORUPDATE_COST_CENTRE_SUCCESS,
      addOrUpdateCostCentreSuccess,
    );

    usermanagementStore.addChangeListener(
      UsermanagementConstants.ADDORUPDATE_COST_CENTRE_FAILURE,
      addOrUpdateCostCentreFailure,
    );

    return () => {
      usermanagementStore.removeChangeListener(
        UsermanagementConstants.ADDORUPDATE_COST_CENTRE_SUCCESS,
        addOrUpdateCostCentreSuccess,
      );

      usermanagementStore.removeChangeListener(
        UsermanagementConstants.ADDORUPDATE_COST_CENTRE_FAILURE,
        addOrUpdateCostCentreFailure,
      );
    };
  }, []);
  //------------------------Add or update cost centre section end ----------------------
  const confirmationOkCancelCallback = (isConfirmed, eventType, data) => {
    if (isConfirmed) {
      switch (eventType) {
        case "DELETE_ROLE":
          deleteRoleForUser(data.userRoleId);
          closePopUpCallback();
          break;
        case "DELETE_COST_CENTRE":
          deleteCostCentreForUser(data.roleId, data.costCentreId);
          closePopUpCallback();
          break;
        case "ENABLE_USER":
          unblockUser(data.userid);
          closePopUpCallback();
          break;
        case "RESET_USER_PASSWORD":
          resetUserPassword(data.userid);
          closePopUpCallback();
          break;
        default:
          closePopUpCallback();

          break;
      }
    } else {
      closePopUpCallback();
    }
  };

  const closePopUpCallback = () => {
    setConfirmationPopUpOpen(false);
    setConfirmationPopUpMsg("");
    setCallbackData(null);
    setEventType(null);
  };

  const filteruserList = (_enterText) => {
    let tempUserList = [...originalUserData];
    const res = customizeFilter(tempUserList, _enterText, "id");
    setUserList(res);
  };

  const handleSorting = (headerSel) => {
    let sortedList = [...userlist];
    setUserList([]);
    let list1;
    if (orderKey === "Asc") {
      list1 = sortedList.sort((a, b) => {
        if (a[headerSel] == null) {
          a[headerSel] = "";
        }
        if (b[headerSel] == null) {
          b[headerSel] = "";
        }
        if (headerSel === "aktiv" || headerSel === "isExtern") {
          return a[headerSel] > b[headerSel] ? 1 : -1;
        } else {
          return a[headerSel].trim().toLowerCase() >
            b[headerSel].trim().toLowerCase()
            ? 1
            : -1;
        }
      });
      setOrderKey("Dsc");
    } else {
      list1 = sortedList.sort((a, b) => {
        if (a[headerSel] == null) {
          a[headerSel] = "";
        }
        if (b[headerSel] == null) {
          b[headerSel] = "";
        }
        if (headerSel === "aktiv" || headerSel === "isExtern") {
          return a[headerSel] < b[headerSel] ? 1 : -1;
        } else {
          return a[headerSel].trim().toLowerCase() <
            b[headerSel].trim().toLowerCase()
            ? 1
            : -1;
        }
      });
      setOrderKey("Asc");
    }
    setUserList(list1);
    setOrderSymbol({
      columName: headerSel,
      className:
        orderKey === "Asc"
          ? "glyphicon glyphicon-chevron-up"
          : "glyphicon glyphicon-chevron-down",
    });
  };

  function handleCellStyle(_value) {
    return activeTranslation.includes(_value.toLowerCase()) ? (
      <span className="badge badge-success rounded-pill d-inline">
        {localization.active}
      </span>
    ) : (
      <span className="badge badge-danger rounded-pill d-inline">
        {localization.inActive}
      </span>
    );
  }
  const operations = {
    RowOperationList: [
      {
        label: "Edit",
        component: <RenderEditButton />,
        onClick: handleEdit,
      },
      {
        label: "Unblock",
        component: <RenderUnBlockUser />,
        onClick: handleUnBlockUser,
        condition: {
          handleMethod: (row) =>
            !activeTranslation.includes(row.aktiv.toLowerCase()),
        },
      },
      {
        label: "Block",
        component: <RenderBlockUser />,
        onClick: handleBlockUser,
        condition: {
          handleMethod: (row) =>
            activeTranslation.includes(row.aktiv.toLowerCase()),
        },
      },
      {
        label: "ViewRole",
        component: <RenderViewRoleButton />,
        onClick: handleViewRole,
      },
      {
        label: "AddRole",
        component: <RenderAddRoleButton />,
        onClick: handleRoleAdd,
      },
      {
        label: "ResetPassword",
        component: <RenderResetpasswordButton />,
        onClick: handleResetPassword,
      },
    ],
    GridToolBarAction: [
      {
        label: "Add",
        component: <RenderAddUserButton />,
        onClick: handleAdd,
      },
      {
        label: "Import",
        component: <RenderImportButton />,
        onClick: handleImportClick,
      },
    ],
  };

  function handleImport(seletedFile, plantId) {
    setGlobalSpinner(true);

    const obj = {
      ImportType: "User",
      WerkId: plantId,
      ImportFile: seletedFile,
    };
    ImportAction.uploadData(obj);
  }

  function handleCloseImport(_message) {
    if (_message === "success") {
      getFilteredUsers();
    }
    setOpenImport((prev) => ({
      ...prev,
      isOpen: false,
    }));
  }

  function handleDownloadTemplate(plantId) {
    ImportAction.getTemplate({
      ImportType: "User",
      UpdateTempalte: false,
      WerkId: plantId,
    });
    setGlobalSpinner(true);
  }
  function getAction(params) {
    const _acionList = [];
    _acionList.push(
      <GridActionsCellItem
        label={localization.toolTipEdit}
        data-toggle="modal"
        data-target="#addNewUser"
        showInMenu
        onClick={() => handleEdit(params.row)}
      />,
    );
    if (!params["row"].aktiv) {
      _acionList.push(
        <GridActionsCellItem
          label={localization.unblock}
          showInMenu
          onClick={() => handleUnBlockUser(params.row)}
        />,
      );
    }
    if (params["row"].aktiv) {
      _acionList.push(
        <GridActionsCellItem
          label={localization.block}
          showInMenu
          data-toggle="modal"
          data-target="#blockModal"
          onClick={() => handleBlockUser(params.row)}
        />,
      );
    }
    _acionList.push(
      <GridActionsCellItem
        label={localization.viewRole}
        showInMenu
        data-toggle="modal"
        data-target="#viewRoleModal"
        onClick={() => handleViewRole(params.row)}
      />,
    );
    _acionList.push(
      <GridActionsCellItem
        label={localization.addRole}
        showInMenu
        data-toggle="modal"
        data-target="#addRoleModal"
        onClick={() => handleRoleAdd(params.row)}
      />,
    );
    _acionList.push(
      <GridActionsCellItem
        label={localization.resetPassword}
        showInMenu
        onClick={() => handleResetPassword(params.row)}
      />,
    );
    return _acionList;
  }
  return (
    <>
      <div
        id="content"
        style={{ height: "100%", width: "100%", overflow: "auto" }}
      >
        <AlertMessage
          showAlertMessage={showAlertMessage}
          isAlertSuccess={isAlertSuccess}
          alertmessage={alertMessage}
        />
        {userlist && (
          <CustomDataGrid
            Title={
              localization.orgSetting + " / " + localization.userManagement
            }
            columns={columns}
            rows={userlist}
            operations={operations}
            onAdd={() => {}}
            showExport={true}
            showColumns={true}
            showFilters={true}
            showDensity={true}
            visibleColumns={[
              "vorname",
              "nachname",
              "username",
              "email",
              "personalNr",
              "werkID",
              "lastLoginOn",
              "mobileLoginOn",
              "isExtern",
              "aktiv",
            ]}
            showCheckBox={false}
            columnStyles={columnStyles}
            handleCellStyle={handleCellStyle}
            gridTableHeight={"dataGridLarge"}
          />
        )}
      </div>
      {openImport.isOpen && <ImportComponent data={openImport} />}
      <Addnewuser userDetails={userdetails} />
      <DisableEnableUser userId={userId} />
      <AddRole
        userId={userId}
        isAddRole={isAddRole}
        editRoleDetails={editRoleDetails}
      />
      <ViewRole
        userId={userId}
        userDetails={userdetails}
        userRoleList={userRoleList}
        costCentreListForUser={costCentreListForUser}
        editRoleFuntionCallback={editRoleFuntionCallback}
        addCostCentreFuntionCallback={addCostCentreFuntionCallback}
        editCostCentreFunctionCallback={editCostCentreFunctionCallback}
        closeViewRolePopUpCallback={closeViewRolePopUpCallback}
        deleteRoleCallback={deleteRoleCallback}
        deleteCostCentreCallback={deleteCostCentreCallback}
      />
      <ConfirmationPopUp
        isOpen={confirmationPopUpOpen}
        okCancelCallback={confirmationOkCancelCallback}
        close={closePopUpCallback}
        title=""
        msg={confirmationPopUpMsg}
        eventType={eventType}
        callbackData={callbackData}
      />
      <AddCostCentreForUser
        addCostCentreDetails={addCostCentreDetails}
        costCentreList={costCentreList}
      />
    </>
  );
};

export default Masterpage;
